import httpClient from 'src/common/fetch/config'
import { PartnerRevenueModel, RevenuePreview, RevenuePreviewParams } from './models'

// GET /revenue/partner — the authenticated partner's visible settlement records (auto-scoped server-side).
export const getPartnerRevenue = () => httpClient.get<PartnerRevenueModel[]>('/revenue/partner')

// GET /revenue/partner/document?id= — a short-lived presigned URL for the statement PDF.
export const getPartnerRevenueDocumentUrl = (id: string) =>
  httpClient.get<{ url: string }>(`/revenue/partner/document?id=${id}`)

// GET /revenue/preview — backend-computed period figures (gross earned, net rate, avg balance).
export const getRevenuePreview = (params: RevenuePreviewParams) =>
  httpClient.get<RevenuePreview>('/revenue/preview', { params })

// POST /revenue/partner/claim — partner claims their settlement (server scopes to the caller's org).
export const claimPartnerRevenue = (dto: { organizationId: string; id: string }) =>
  httpClient.post<PartnerRevenueModel>('/revenue/partner/claim', dto)

// PATCH /revenue/partner/comment — partner saves a comment on their own unclaimed settlement (no claim).
export const commentPartnerRevenue = (dto: { id: string; comments: string }) =>
  httpClient.patch<PartnerRevenueModel>('/revenue/partner/comment', dto)
